import API, { baseURL } from './api';
import { getSucursalInfo } from './auth';

// "Configurações" (menuConfig.js: pagamentos.configuracoes, /pagamentos/configuracoes)
// — three sub-screens sharing this one service module:
//   - Multas   → sge_infantil_core routes/fineconfig.js   (mounted at /api/fines)
//   - Pagamentos → sge_infantil_core routes/paymentconfig.js (mounted at /api/paymentconfig)
//   - Pautas   → two flags on the Sucursal record itself, updated via
//     routes/sucursal.js's generic PUT (there's no dedicated table for this,
//     it's a per-sucursal on/off switch like `useReportCards`).

// ---------------------------------------------------------------------------
// Configuração de Multas (fine_config)
// ---------------------------------------------------------------------------
export async function listFineConfigs(sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/fines/all/${id}`);
}

export async function createFineConfig(payload) {
  const sucursalId = getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/fines`, { sucursalId, ...payload });
}

export async function updateFineConfig(id, payload) {
  const sucursalId = getSucursalInfo()?.id || 1;
  return API.put(`${baseURL}api/fines/${id}`, { sucursalId, ...payload });
}

export async function deleteFineConfig(id) {
  return API.delete(`${baseURL}api/fines/${id}`);
}

// ---------------------------------------------------------------------------
// Configuração de Pagamentos (PaymentConfig) — um registo por sucursal
// ---------------------------------------------------------------------------
export async function getPaymentConfig(sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/paymentconfig/all/${id}`);
}

export async function createPaymentConfig(payload) {
  const sucursalId = getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/paymentconfig`, { sucursalId, ...payload });
}

export async function updatePaymentConfig(id, payload) {
  return API.put(`${baseURL}api/paymentconfig/${id}`, payload);
}

// ---------------------------------------------------------------------------
// Configuração de Pautas — flags no próprio registo de Sucursal
// ---------------------------------------------------------------------------
export async function getSucursal(sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/sucursal/${id}`);
}

export async function updateSucursalPautaConfig(sucursalId, { pautaVisivelWhatsapp, pautaBloqueiaComPagamentoEmAtraso, isCambridge }) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  const fields = { pautaVisivelWhatsapp, pautaBloqueiaComPagamentoEmAtraso };
  if (isCambridge !== undefined) fields.isCambridge = isCambridge;
  return API.put(`${baseURL}api/sucursal/${id}`, fields);
}
